// extracted by mini-css-extract-plugin
export default {"container":"travelpopular_container__CgjcK","title":"travelpopular_title__+nZFU","mainbox":"travelpopular_mainbox__e3TmE"};